/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../notes/notes.ts"/>
/// <reference path="./contract_invoice.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareContractFactory {
        loadContract(locationId: number, id: number): ng.IPromise<{}>;
        getInstance(): IDealerwareContract;
    }

    export interface IDealerwareContract extends IDealerwareHasNotes {
        contractId: number;
        currentInvoice: IDealerwareContractInvoiceCurrent;

        contractDetails: any;
        insurance: any;
        insuranceImage: any;
        vehicles: any;
        vehicleIssues: any;
        warranty: any;

        clear() : void;
        clearContractDetails() : void;
        loadContractDetails(locationId?: number, id?: number) : ng.IPromise<{}>;
        loadDriversLicense(id?: number) : ng.IPromise<{}>;
        loadAdditionalDrivers(id?: number) : ng.IPromise<{}>;
        loadInsurance(id?: number) : ng.IPromise<{}>;
        loadInsuranceImage(id?: number) : ng.IPromise<{}>;
        deleteInsuranceImage(id?: number) : ng.IPromise<{}>;
        loadVehicleContracts(id?: number) : ng.IPromise<{}>;
        loadVehicleIssues(id?: number) : ng.IPromise<{}>;
        loadWarranty(id?: number) : ng.IPromise<{}>;
        canCancel() : boolean;
        cancel(id?: number) : ng.IPromise<{}>;
        canModify() : boolean;
        canStart() : boolean;
        canFinish() : boolean;
        isStarted() : boolean;
        loadCurrentInvoice() : ng.IPromise<{}>;
        loadNotes() : ng.IPromise<{}>;
    }

    export interface IDealerwareContractInvoice {
        locationId: number;
        contractId: number;
        data: {};
        pricingSectionDefinitions: {}[];
        paymentSectionDefinitions: {}[];
        invoiceURL: string;
        pricingSection: any;
        declinedPaymentSection: any;
        paymentSection: any;
        validPricingSections: {}[];
        paymentSections: {}[];
        balance: string;
        total: string;
        currencyCode: string;
        currencySymbol: string;
        id: number;

        load() : ng.IPromise<{}>;
        clear() : void;
        hasPricingSectionItems(section: string) : boolean;
    }

    export interface IDealerwareContractInvoiceCurrent extends IDealerwareContractInvoice {}

    export interface IDealerwareContractInvoiceFactory {
        getCurrentInvoiceInstance(locationId: number, contractId: number) : IDealerwareContractInvoiceCurrent;
        getInvoiceInstance(contractId: number) : IDealerwareContractInvoice;
    }
}
